import { useDatabaseSelectionSnapshot } from '@databases/ping-registry';

/**
 * Supports the legacy redux selector and ping registry for reactive updates.
 */
export function useValueIsOnlySelected(
  entryId: string | undefined,
  fieldId: string
): boolean {
  const pingValue = useDatabaseSelectionSnapshot((reader) => {
    if (!entryId) {
      return false;
    }

    return reader.getSelectionCount() === 1 && reader.isValueSelected(entryId, fieldId);
  });

  return pingValue;
}
